import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function PumpGraph({ data, color }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data || []}
        margin={{ top: 0, right: 10, left: 0, bottom: 5}}
      >
        <XAxis
          dataKey="time"
          tick={{ fontSize: 10 }}
          label={{ value: "Time (HH:mm)", position: "insideBottom", offset: -5, fontSize: 10 }}
        />
        <YAxis
          tick={{ fontSize: 8 }}
          label={{ value: "Active State", angle: -90, position: "insideLeft", offset: 50, dy: 20, fontSize: 8 }}
          ticks={[0, 1]}  // For boolean steps
          domain={[0, 1]}
        />
        <Tooltip formatter={(value) => (value === 1? "ON" : "OFF")} />
        <Line
          type="stepAfter"
          dataKey="value"
          stroke={color}
          strokeWidth={2}
          dot={{ r: 3 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
